// removed by extract-text-webpack-plugin
module.exports = {"invoice":"style__invoice__2Q5EH","status":"style__status__BSROa","paid":"style__paid__lBXdJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/settings/invoices/style.scss
// module id = 471
// module chunks = 0